import React from "react";
// import "./Showroom.scss";
function ProductCut(props) {
    return (
        <div className="ProductCutDetails">
            {props.productDetails.map((products) => (
                <>
                    <a className="ProductCut">
                        <div className="ProductCutImage">
                            <img
                                src={`/Images/Showroom/${products.image}`}
                            ></img>
                        </div>
                        <ul className="ProductCutText">
                            <li>{products.brandName}</li>
                            <li>{products.productName}</li>
                            <li>{products.modelNum}</li>
                            <li>{products.price}</li>
                        </ul>
                    </a>
                </>
            ))}
        </div>
    );
}

export default ProductCut;
